import { AUTH_HEADERS, getSourceLocation } from '@libs/core';

export function buildSourceLocationHeader(): HeadersInit {
    return {
        [AUTH_HEADERS.X_PETM_SOURCE_LOCATION]: String(getSourceLocation()),
    };
}
